import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { type: String }

  ANIMATION_FADE_IN = 'animate-fade-in'
  ANIMATION_SHAKE = 'animate-shake'
  ANIMATION_DURATION_SEC = 0.5

  constructor(context) {
    super(context)
    this.hideOnClickOutside = this.hideOnClickOutside.bind(this)
  }

  show() {
    this.#withAnimation(this.animation, () =>
      this.element.classList.remove('hidden')
    )
    // don't listen for click event right away
    setTimeout(() => this.#addClickEventListener(), 1000)
  }

  hide() {
    this.#removeClickEventListener()
    this.element.classList.add('hidden')
  }

  hideOnClickOutside(event) {
    if (!this.element.contains(event.target)) this.hide()
  }

  #withAnimation(animation, callbackFn) {
    this.element.classList.add(animation)
    callbackFn()
    // remove animation after it's played out
    setTimeout(
      () => this.element.classList.remove(animation),
      this.ANIMATION_DURATION_SEC * 1000
    )
  }

  #addClickEventListener() {
    document.addEventListener('click', this.hideOnClickOutside)
  }

  #removeClickEventListener() {
    document.removeEventListener('click', this.hideOnClickOutside)
  }

  get animation() {
    switch (this.typeValue) {
      case 'warning':
        return this.ANIMATION_FADE_IN
      case 'error':
        return this.ANIMATION_SHAKE

      default:
        return this.ANIMATION_FADE_IN
    }
  }
}
